import type { PropsWithChildren } from 'react'
import { TableCell } from '@/components/ui/table'
import { cn } from '@/lib/utils'

interface TranscriptTableCellProps extends PropsWithChildren {
  className?: string
}

export const TranscriptTableCell = ({
  children,
  className
}: TranscriptTableCellProps) => {
  return (
    <TableCell className={cn('p-4 py-2 border-t border-b border-e', className)}>
      <div className="w-full h-full">{children}</div>
    </TableCell>
  )
}
